export enum EntityWithIdFields {
  Id = 'id',
}

export interface EntityWithId<TId> {
  [EntityWithIdFields.Id]: TId;
}

export enum EntityWithIdAndDescriptionFields {
  Id = 'id',
  Description = 'descripcion',
}

export interface EntityWithIdAndDescription extends EntityWithId<number> {
  [EntityWithIdAndDescriptionFields.Description]: string;
}

export enum BaseResponseFields {
  Data = 'data',
  HasError = 'tieneError',
  ErrorDescription = 'descripcionError',
}

export interface BaseResponseWithData<T> {
  [BaseResponseFields.Data]: T;
  [BaseResponseFields.HasError]: boolean;
  [BaseResponseFields.ErrorDescription]: string;
}

export interface BaseResponse {
    [BaseResponseFields.HasError]: boolean;
    [BaseResponseFields.ErrorDescription]: string;
}














